import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'Site Map',
        href: '/sitemap/',
        classname: 'sitemapMainLink',
        dataTn: 'sitemap-main',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_main'
                defaultMessage='Site Map'
            />
        )
    },
    {
        trackingLabel: 'Furniture',
        href: '/sitemap/furniture/',
        dataTn: 'sitemap-furniture',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_furniture'
                defaultMessage='Furniture'
            />
        )
    },
    {
        trackingLabel: 'Jewelry & Watches',
        href: '/sitemap/jewelry/',
        dataTn: 'sitemap-jewelry',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_jewelry'
                defaultMessage='Jewelry & Watches'
            />
        )
    },
    {
        trackingLabel: 'Fine Art',
        href: '/sitemap/art/',
        dataTn: 'sitemap-art',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_art'
                defaultMessage='Fine Art'
            />
        )
    },
    {
        trackingLabel: 'Fashion',
        href: '/sitemap/fashion/',
        dataTn: 'sitemap-fashion',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_fashion'
                defaultMessage='Fashion'
            />
        )
    },
    {
        trackingLabel: 'Creators',
        href: '/creators/',
        dataTn: 'creators',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.sitemap_links_creators'
                defaultMessage='Creators'
            />
        )
    }
];



// WEBPACK FOOTER //
// ./src/components/Footer/messages/sitemapLinks.jsx